module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-48x48-248dff7a6e126453f58bf49ea31bac9d.png";